<div 
    class="z-30 fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75"
    (click)="$event.preventDefault(); handleCloseTeam();"
>
    <div class="max-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
        <div class="w-full max-w-screen-sm flex flex-col my-6 p-8 gap-4 bg-white rounded-md shadow-lg overflow-hidden" (click)="$event.stopPropagation()">
            <div class="flex h-full overflow-y-auto">
                <div class="w-full flex flex-col overflow-hidden">
                    <h2 class="text-center oswald-font text-3xl mb-2">THREAT ASSESSMENT TEAM</h2>
                    <h2 class="text-center text-lg mb-4">for case {{ caseId }}</h2>
                    <div class="flex-grow overflow-y-auto">
                        <ng-container *ngIf="selectedContacts.length > 0; else emptySelectedContact">            
                            <div class="grid grid-cols-2 items-center gap-2 mb-2">
                                <div *ngFor="let selectedContact of selectedContacts; let i = index;"
                                    class="h-10 gap-2 flex-grow px-2.5 py-1.5 flex items-center justify-between rounded-md bg-gray-50"
                                >
                                    <p class="w-10 h-full flex items-center"> {{ i + 1 }}.</p>
                                    <p class="w-full">{{ selectedContact.name }}</p>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #emptySelectedContact>
                            <div class="text-center text-nside-gray-100 italic">
                                Empty
                            </div>
                        </ng-template>
                    </div>
                    <div class="mt-4 flex justify-end gap-2 oswald-font">
                        <button
                            class="py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                            (click)="$event.preventDefault(); handleCloseTeam();"
                        >
                            Close
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>